import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { SanctumAuthService } from '@fsf/auth';
import { TranslateModule } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ToastModule } from 'primeng/toast';
import { of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { UserService } from '../../shared/services/user.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    PasswordModule,
    CardModule,
    ToastModule,
    FloatLabelModule,
    TranslateModule,
  ],
  providers: [MessageService],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss',
})
export class LoginPageComponent {
  email = '';
  password = '';
  loading = false;

  #router = inject(Router);
  #messageService = inject(MessageService);
  #auth = inject(SanctumAuthService);
  #user = inject(UserService);

  onLogin() {
    if (!this.email || !this.password) {
      this.#messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please enter both email and password',
      });
      return;
    }

    this.loading = true;
    this.#auth
      .signIn({ email: this.email, password: this.password }, true)
      // this.#authService
      //   .login({ email: this.email, password: this.password })
      .pipe(
        catchError((error) => {
          console.log(error);
          this.#messageService.add({
            severity: 'error',
            summary: 'Login Failed',
            detail:
              error.error?.message || 'Invalid credentials or server error',
          });
          return of(null);
        }),
        finalize(() => {
          this.loading = false;
        }),
      )
      .subscribe({
        next: (response) => {
          if (response) {
            this.#user.setUser(response.data);
            this.#messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Login successful',
            });
            // Navigate to list page after successful login
            this.#router.navigate(['/locations/list']);
          }
        },
      });
  }

  showForgotPassword(e: any) {
    e.preventDefault();
    this.#router.navigate(['/forgot-password']);
  }
}
